import { Box, Label } from '@medely/ui-kit';
import React from 'react';

declare global {
  interface Window {
    Intercom: any;
  }
}

export const ChatWithSupport = () => {
  const intercomMethod = (...args: any[]) => {
    if (typeof window !== 'undefined' && typeof window.Intercom === 'function') {
      console.warn('Intercom method called with args:', args);
      return window.Intercom(...args);
    }
  };

  function show() {
    intercomMethod('showNewMessage', 'I would like to update my phone number!');
  }

  return (
    <Box onClick={() => show()} pl={4}>
      <Label size="m" color="state.teal.secondary">
        Chat with support to update number
      </Label>
    </Box>
  );
};
